import { render } from "./CheckboxWithLabel.vue?vue&type=template&id=19510dbb"
import script from "./CheckboxWithLabel.vue?vue&type=script&lang=js"
export * from "./CheckboxWithLabel.vue?vue&type=script&lang=js"

import exportComponent from "/Users/viktor/Desktop/projects/u2c/x5-group/mission-accomplished/backend/project/packages/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CheckboxWithLabel.vue"]])

export default __exports__